var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card-container",style:(_vm.bg_color ? { backgroundColor: _vm.bg_color } : null)},[(!_vm.hide_title)?_c('div',{staticClass:"row-div"},[_c('div',{staticClass:"row-info-div"},[_c('div',{staticClass:"title-div"},[_vm._t("title")],2)])]):_vm._e(),_c('div',{staticClass:"card-body"},[_vm._t("content")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }